import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import A_SelectBox from 'components/1_Atoms/A_SelectBox'
import A_IconMust from '../A_IconMust'
import { select } from 'types/SearchTypes'
import { HtmlToolTip } from 'assets/ToolTips'
import { selectF } from 'types/FunctionTypes'
import { createStyles, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() =>
  createStyles({
    label: {
      width: 100,
      align: 'left',
    },
    select: {
      flexGrow: 1,
      align: 'left',
      width: 'calc(100% - 100px)',
    },
  }),
)

type Props = {
  label: string
  must?: boolean
  valueCode: string
  valueSet?: select[]
  event?: selectF
  disabled?: boolean
  lib?: boolean
}

const M_FieldSelect = ({ label, must = false, valueCode, valueSet = [], event = () => {}, disabled = false, lib = true }: Props) => {
  const classes = useStyles()
  const newSelect: select = { value: '', label: '' }
  const selected: select =
    valueSet.find((data) => {
      return data && data.value === valueCode
    }) ?? newSelect

  return (
    <Grid container justifyContent="flex-start" alignItems="center">
      <div className={classes.label}>
        <HtmlToolTip title={<Typography variant="body2">{selected.label}</Typography>} placement="bottom-start">
          <Typography variant="body1" display="block">
            {label}
            <A_IconMust must={must} />
          </Typography>
        </HtmlToolTip>
      </div>
      <div className={classes.select}>
        <A_SelectBox valueSet={valueSet} defValue={selected} event={event} lib={lib} disabled={disabled} />
      </div>
    </Grid>
  )
}

export default React.memo(M_FieldSelect)
